import React, { useEffect, useState } from "react";
import { useTheme } from "../contexts/ThemeContext";

const LINES = [
  "Worn by few. Known by those who matter.",
  "Not for everyone. Exactly as intended.",
  "The future doesn't wait. Neither do we.",
];

export default function TypingLine() {
  const { reduceMotion } = useTheme();
  const [idx, setIdx] = useState(0);
  const [text, setText] = useState("");
  const [phase, setPhase] = useState("typing"); // typing | hold | erasing

  useEffect(() => {
    if (reduceMotion) {
      setText(LINES[0]);
      return undefined;
    }
    let timer;
    const target = LINES[idx];
    if (phase === "typing") {
      if (text.length < target.length) {
        timer = setTimeout(() => setText(target.slice(0, text.length + 1)), 40);
      } else {
        timer = setTimeout(() => setPhase("hold"), 2400);
      }
    } else if (phase === "hold") {
      timer = setTimeout(() => setPhase("erasing"), 600);
    } else if (phase === "erasing") {
      if (text.length > 0) {
        timer = setTimeout(() => setText(target.slice(0, text.length - 1)), 22);
      } else {
        setPhase("typing");
        setIdx((i) => (i + 1) % LINES.length);
      }
    }
    return () => clearTimeout(timer);
  }, [text, phase, idx, reduceMotion]);

  return (
    <div className="font-mono text-[0.78rem] tracking-mt uppercase" data-testid="hero-typing">
      <span style={{ color: "var(--mt-text-muted)" }}>{">"} </span>
      <span style={{ color: "var(--mt-text)" }}>{text}</span>
      {!reduceMotion && <span className="mt-caret mt-keep-anim" aria-hidden="true">&nbsp;</span>}
    </div>
  );
}
